import '../scss/app.scss';
import { helperFuncs } from './components/helpers';
import { initStickyNavbar } from './components/sticky-navbar';
import { carouselHandler } from './components/carouselHandler';
import { mobileNav } from './components/mobile-nav';
import { initTrianglePosition } from './components/trianglePosition';
import A11yDialog from 'a11y-dialog'

const app = {
  settings: {},

  init(): void {
    helperFuncs.convertSVG();
    initStickyNavbar('.main-header', 200);
    carouselHandler.init();
    mobileNav();
    
    const triangles = initTrianglePosition('.page-wrapper--page-triangles');

    const container = document.querySelector('#galleryModal');
    
    if (container instanceof HTMLElement) {
      const dialog = new A11yDialog(container);
    
      dialog.on('show', (ev: Event) => {
        const { detail } = ev as unknown as CustomEvent<{ target?: HTMLElement }>;
        const opener = detail?.target ?? null;
    
        const url =
          opener?.closest('.gallery-item')?.getAttribute('data-image') ??
          opener?.getAttribute('src') ??
          '';
    
        const alt = opener?.querySelector('img')?.getAttribute('alt') ?? '';
    
        const dlg = ev.target as HTMLElement;
        const wrapper = dlg.querySelector('.image-wrapper') as HTMLElement | null;
    
        if (wrapper && url) {
          wrapper.replaceChildren();
          const img = new Image();
          img.src = url;
          img.alt = alt;
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          wrapper.appendChild(img);
        }
      });
    
      dialog.on('hide', (ev: Event) => {
        const dlg = ev.target as HTMLElement;
        (dlg.querySelector('.image-wrapper') as HTMLElement | null)?.replaceChildren();
      });
    }    
  }
};

document.addEventListener('DOMContentLoaded', () => {
  app.init();
});